import { Types } from "../../actions/user/activateUser.actions";

const INITIAL_STATE = {
  success: false,
  loading: false,
  error: null
};

export default function activateUser(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ACTIVATE_USER: {
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    }

    case Types.ACTIVATE_USER_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
        error: null
      };
    }

    case Types.ACTIVATE_USER_ERROR: {
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    }

    case Types.ACTIVATE_USER_RESET: {
      return {
        ...state,
        ...INITIAL_STATE
      };
    }

    default:
      return state;
  }
}
